import { apiGet, apiPost } from './client';
import type { DayOpenStatus, DayOpenRunParams, DayOpenQueued } from '../types/DayOpen';

// Day-Open is a cross-tenant operator action: the endpoints are [NoTenantContext]
// and take the target tenant as an explicit `tenantId` query param (the operator
// acts on many tenants from one session; the backend authorizes each tenantId
// against the user's allowed tenants). No X-Tenant-Id header is used here.
export function getDayOpenStatus(tenantId: number): Promise<DayOpenStatus> {
  return apiGet<DayOpenStatus>(`/api/day-open/status?tenantId=${tenantId}`);
}

// Day-open runs in the BACKGROUND: this queues a run and answers 202 {runId} at once (409 = a run is
// already queued/running). Progress comes from getDayOpenStatus(...).latestRun.
// Optional valuation params (from the modal) are written before the day opens.
export function runDayOpen(
  tenantId: number,
  params?: DayOpenRunParams,
): Promise<DayOpenQueued> {
  return apiPost<DayOpenRunParams | undefined, DayOpenQueued>(
    `/api/day-open/run?tenantId=${tenantId}`,
    params,
  );
}
